export default __webpack_public_path__ + "static/media/silvermoon3.dae61b01.jpg";